<script>
import baseMixin from '@/mixins/baseMixin'
import { mapActions } from 'vuex'
import JsonDataRenderer from '@/components/general/json-data-renderer.vue'
import ClientBullhornErrorBlock from './client-bullhorn-error-block.vue'

export default {
  name: 'TheClientLegacyBullhornDataContainer',
  components: {
    ClientBullhornErrorBlock,
    JsonDataRenderer,
  },
  mixins: [baseMixin],
  props: {
    clientId: {
      type: Number,
      required: true,
    },
  },
  data: () => {
    return {
      rawData: null,
      loading: false,
      error: null,
    }
  },

  async created() {
    await this.loadBullhornData()
  },
  methods: {
    ...mapActions('client', ['getBullhornData']),
    async loadBullhornData() {
      this.error = null

      this.loading = true

      const { isSuccess, data, errors } = await this.getBullhornData(
        this.clientId
      )

      this.loading = false

      if (!isSuccess) {
        this.error = {
          code: errors?.data?.code || 'unknown_error',
          status: errors?.status,
          message: errors?.data?.message,
        } || {
          code: 'unknown_error',
          status: null,
          message: '',
        }
        return
      }

      this.rawData = data
    },
  },
}
</script>

<template>
  <div v-if="loading" class="h-100 d-flex justify-center align-center">
    <v-progress-circular
      :size="120"
      :width="7"
      color="primary"
      indeterminate
    ></v-progress-circular>
  </div>

  <ClientBullhornErrorBlock
    v-else-if="error"
    :error="error"
    :client-id="clientId"
    @retry="loadBullhornData"
  />

  <v-card v-else :class="{ 'custom-elevation': isEmbedded }" flat>
    <JsonDataRenderer :json="rawData" />
  </v-card>
</template>
